import React, { useEffect, createElement } from 'react';
export function SocialProof() {
  useEffect(() => {
    // Load Trustpilot script dynamically
    const script = document.createElement('script');
    script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      // Cleanup script if component unmounts
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <section className="bg-white py-10 border-b border-gray-100" data-id="element-137">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-138">
        <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-6" data-id="element-139">
          Uitstekend beoordeeld door hondenbaasjes
        </p>

        {/* TrustBox widget - Micro Combo */}
        <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="54ad5defc6454f065c28af8b" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="240px" data-style-width="100%" data-token="e93f577b-0bf3-41b2-a38e-a787d1dd7ad9" data-stars="1,2,3,4,5" data-review-languages="nl" data-id="element-140">
          <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-141">
            Trustpilot
          </a>
        </div>
        {/* End TrustBox widget */}
      </div>
    </section>;
}